import { useAdditionalNode } from '@yimoka/react';
import { Space as AntSpace, SpaceProps } from 'antd';
import { SpaceCompactProps } from 'antd/es/space/Compact';
import React from 'react';

const SpaceFC = (props: SpaceProps) => {
  const { direction, orientation, separator, ...rest } = props;
  const curSeparator = useAdditionalNode('separator', separator);

  return (
    <AntSpace {...rest} orientation={orientation ?? direction} separator={curSeparator} />
  );
};

export const Space = Object.assign(SpaceFC, {
  Compact: AntSpace.Compact,
});

export type { SpaceCompactProps, SpaceProps };
